// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2p7_t","right":"Footer_right__2nZw0","buttons":"Footer_buttons__1UENK"};